<template>
  <div class="d-block">
    <!--    <toggle-switch-->
    <!--      :options="switcherOptions"-->
    <!--      @change="updateValues()"-->
    <!--      v-model="selectedValue"-->
    <!--      class="switcher-container"-->
    <!--    ></toggle-switch>-->
    <ul class="radio-switch d-block" :class="selectedClass">
      <li
        v-for="(item, index) in elems"
        :key="index"
        :class="'radio-switch__item item-' + index"
      >
        <input
          :class="'radio-switch__input sr-only item-' + index"
          type="radio"
          :ref="'index' + index"
          :name="'radioButton' + item.value"
          :id="'radio' + item.value"
          :value="item.value"
          @change="updateValues(index)"
          v-model="selected"
        />
        <label class="radio-switch__label" :for="'radio' + item.value">{{
          item.name
        }}</label>
        <div
          aria-hidden="true"
          :class="'radio-switch__marker item-' + index"
          v-if="index === 0"
        ></div>
      </li>

      <!--      <li class="radio-switch__item">-->
      <!--        <input class="radio-switch__input sr-only" type="radio" name="radioButton" id="radio2">-->
      <!--        <label class="radio-switch__label" for="radio2">Yearly</label>-->
      <!--        <div aria-hidden="true" class="radio-switch__marker"></div>-->
      <!--      </li>-->
    </ul>
  </div>
</template>

<script>
import ToggleSwitch from "vuejs-toggle-switch";
export default {
  name: "RadioSwitcher",
  components: {
    ToggleSwitch
  },
  props: {
    value: String,
    elems: Array
  },
  data: () => {
    return {
      firstValue: null,
      switcherOptions: {},
      selected: null,
      selectedIndex: 0
    };
  },
  mounted() {
    this.selected = this.value;
    this.elems.forEach((elem, index) => {
      if (elem.value === this.selected) {
        this.selectedIndex = index;
      }
    });
  },
  methods: {
    updateValues(index) {
      this.selectedIndex = index;
      this.$emit("input", this.selected);
    }
  },
  computed: {
    selectedClass() {
      return `radio-switch__selected-${this.selectedIndex} total-items-${this.elems.length}`;
    }
  }
};
</script>

<style></style>
